import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200 py-16 px-6 bg-slate-50" data-testid="app-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-lg bg-teal-500 flex items-center justify-center">
                <Sparkles className="h-4 w-4 text-white" />
              </div>
              <span className="text-lg font-bold text-slate-900">Ariskool</span>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed">Modern leave management built for Indian schools.</p>
          </div>
          {[
            {
              title: 'Product',
              links: [
                { label: 'Features', to: '/features' },
                { label: 'Pricing', to: '/pricing' },
                // { label: 'Tutorials', to: '/tutorials' },
              ],
            },
            {
              title: 'Company',
              links: [
                { label: 'About', to: '/about' },
                { label: 'Contact', to: '/contact' },
              ],
            },
            {
              title: 'Legal',
              links: [
                { label: 'Privacy', to: '/privacy' },
                { label: 'Terms', to: '/terms' },
                { label: 'Security', to: '/security' },
                // { label: 'RTI', to: '/rti' },
              ],
            },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-slate-600 hover:text-teal-600 transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><a href="/tutorials" className="text-sm text-slate-600 hover:text-teal-600 transition-colors">Tutorials</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-slate-400">
          <span>&copy; 2026 Ariskool. All rights reserved.</span>
          <span>
            A product of{' '}
            <a href="https://arismeta.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 transition-colors font-semibold">
              Arismeta
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};
